export default "__VITE_ASSET__a0d24f5f__"